import { render } from "./NetherlandLuage.vue?vue&type=template&id=0ad43ecc&scoped=true"
import script from "./NetherlandLuage.vue?vue&type=script&lang=js"
export * from "./NetherlandLuage.vue?vue&type=script&lang=js"

import "./NetherlandLuage.vue?vue&type=style&index=0&id=0ad43ecc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ad43ecc"]])

export default __exports__